export const EVENT_IN_PLAY_CHANGE = 'pds/EVENT_IN_PLAY_CHANGE';
export const CASH_IN_PRICE_CHANGE = 'pds/CASH_IN_PRICE_CHANGE';
export const CONNECTED = 'pds/CONNECTED';
export const CONNECTION_ERROR = 'pds/CONNECTION_ERROR';

export const cashInPriceChange = () => ({
  type: CASH_IN_PRICE_CHANGE
});

export const eventInPlayChange = ({ eventId, isPreMatch, isInPlay, isPostMatch }) => ({
  type: EVENT_IN_PLAY_CHANGE,
  eventId,
  isPreMatch,
  isInPlay,
  isPostMatch
});

export const connected = () => ({
  type: CONNECTED
});

export const connectionError = () => ({
  type: CONNECTION_ERROR
});
